import { makeGetCsv } from '../make-api'

const REPORT_ACT = '/ReportAct'

const reportActApi = {
  getReportAct: makeGetCsv(REPORT_ACT),
}

export default reportActApi
